/** Дата, с которой можно запросить акт сверки */
export const RECONCILIATION_ACT_MIN_AVAILABLE_DATE = new Date(2026, 5, 1);
